(function () {
  var MOBILE_MAX = 767;
  var mediaQuery = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)');

  function initAccordion(accordion) {
    if (accordion.dataset.nwEffectsBound === 'true') return;
    accordion.dataset.nwEffectsBound = 'true';

    var cards = accordion.querySelectorAll('[data-nw-effects-card]');
    var dots = accordion.querySelectorAll('.nw-effects-accordion__dot');

    function setOpen(card, open) {
      var wrap = card && card.querySelector('.nw-effects-card__body-wrap');
      var trigger = card && card.querySelector('[data-nw-effects-trigger]');
      if (!wrap || !trigger) return;
      if (open) {
        card.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        wrap.style.height = '0px';
        wrap.offsetHeight;
        wrap.style.height = wrap.scrollHeight + 'px';
        wrap.addEventListener('transitionend', function onEnd() {
          wrap.removeEventListener('transitionend', onEnd);
          wrap.style.height = '';
        }, { once: true });
      } else {
        var h = wrap.scrollHeight;
        wrap.style.height = h + 'px';
        wrap.offsetHeight;
        wrap.style.height = '0px';
        card.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function updateDots(openIndex) {
      dots.forEach(function (dot, i) {
        if (i === openIndex) {
          dot.classList.add('nw-effects-accordion__dot--active');
        } else {
          dot.classList.remove('nw-effects-accordion__dot--active');
        }
      });
    }

    function applyMobileState() {
      cards.forEach(function (card, i) {
        var wrap = card.querySelector('.nw-effects-card__body-wrap');
        var trigger = card.querySelector('[data-nw-effects-trigger]');
        if (!wrap || !trigger) return;
        if (card.classList.contains('is-open')) {
          wrap.style.height = '';
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          wrap.style.height = '0px';
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      var openIdx = -1;
      cards.forEach(function (card, i) {
        if (card.classList.contains('is-open')) openIdx = i;
      });
      updateDots(openIdx);
    }

    function applyDesktopState() {
      cards.forEach(function (card) {
        var wrap = card.querySelector('.nw-effects-card__body-wrap');
        var trigger = card.querySelector('[data-nw-effects-trigger]');
        if (wrap) wrap.style.height = '';
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      });
      dots.forEach(function (dot) {
        dot.classList.remove('nw-effects-accordion__dot--active');
      });
      if (dots[0]) dots[0].classList.add('nw-effects-accordion__dot--active');
    }

    cards.forEach(function (card, i) {
      var trigger = card.querySelector('[data-nw-effects-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (!mediaQuery.matches) return;

        var isOpen = card.classList.contains('is-open');
        if (isOpen) {
          setOpen(card, false);
          updateDots(-1);
        } else {
          cards.forEach(function (c) {
            if (c.classList.contains('is-open')) setOpen(c, false);
          });
          setOpen(card, true);
          updateDots(i);
        }
      });
    });

    function syncState() {
      if (mediaQuery.matches) {
        applyMobileState();
      } else {
        applyDesktopState();
      }
    }

    syncState();
    mediaQuery.addEventListener('change', syncState);
  }

  function initSection(container) {
    container = container || document;
    var accordions = container.querySelectorAll('[data-nw-effects-accordion]');
    accordions.forEach(initAccordion);
  }

  function init() {
    initSection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
